import { BKJ_ENVIRONMENT } from 'config';
import { useEffect, useState } from 'react';
import { useAllFeatureFlagsSelector } from 'store/selectors/featureFlagSelectors/allFeatureFlagsSelector';
import { useUserRoleSelector } from 'store/selectors/userSelectors/userRoleSelector';
import { useUserSelector } from 'store/selectors/userSelectors/userSelector';
import {
  useCommunityListSelector,
  useOrgIdSelector,
  useOrgNameSelector,
} from 'store/selectors/organizationSelectors/orgSettingsSelector';
import { useSelector } from 'react-redux';
import { isUserB2bSelector } from 'store/selectors/userSelectors/isUserB2bSelector';
import isUserSecondarySelector from 'store/selectors/userSelectors/isUserSecondarySelector';

export function ChameleonContainer() {
  const features = useAllFeatureFlagsSelector();
  const user_role = useUserRoleSelector();
  const isUserB2B = useSelector(isUserB2bSelector);
  const isUserSecondary = useSelector(isUserSecondarySelector);

  const communities = useCommunityListSelector();
  const orgId = useOrgIdSelector();
  const orgName = useOrgNameSelector();

  const user = useUserSelector();
  const [isMountedForURL, setIsMountedForURL] = useState('');

  useEffect(() => {
    if (user && window?.location?.pathname !== isMountedForURL) {
      const isUserTypeWithCommunities = isUserB2B || isUserSecondary;
      const isCommunitiesDataLoaded = isUserTypeWithCommunities && !!orgId && !!communities?.length;

      if (isUserTypeWithCommunities && !isCommunitiesDataLoaded) return;

      const { id, created_at, email, first_name, last_name } = user;

      window?.chmln?.identify(id, {
        id,
        email,
        created: created_at,
        name: `${first_name} ${last_name}`,
        role: user_role?.toLowerCase(),
        features,
        ...(isCommunitiesDataLoaded && {
          organization_id: orgId,
          organization_name: orgName,
          community_ids: communities.map((c) => c.id),
          community_names: communities.map((c) => c.name),
        }),
        environment: BKJ_ENVIRONMENT,
      });

      setIsMountedForURL(window.location.pathname);
    }
  }, [
    communities,
    features,
    isMountedForURL,
    isUserB2B,
    isUserSecondary,
    orgId,
    orgName,
    user,
    user_role,
  ]);

  return null;
}
